import { gql } from '@apollo/client';

export const WEBHOOKS_FIELDS = gql`
  fragment webhooksFields on Webhook {
    id
    name
    url
    eventType
    secret
  }
`;

export const GET_WEBHOOKS = gql`
  query getWebhooks {
    getWebhooks {
      ...webhooksFields
    }
  }
  ${WEBHOOKS_FIELDS}
`;

export const CREATE_WEBHOOK = gql`
  mutation createWebhook($name: String!, $url: String!, $eventType: WebhookEventType!, $secret: String!) {
    createWebhook(input: { name: $name, url: $url, eventType: $eventType, secret: $secret }) {
      ...webhooksFields
    }
  }
  ${WEBHOOKS_FIELDS}
`;

export const UPDATE_WEBHOOK = gql`
  mutation updateWebhook($id: String!, $name: String, $url: String, $eventType: WebhookEventType, $secret: String) {
    updateWebHook(input: { id: $id, name: $name, url: $url, eventType: $eventType, secret: $secret }) {
      ...webhooksFields
    }
  }
  ${WEBHOOKS_FIELDS}
`;

export const REMOVE_WEBHOOK = gql`
  mutation removeWebhook($id: String!) {
    removeWebhook(input: { id: $id }) {
      ...webhooksFields
    }
  }
  ${WEBHOOKS_FIELDS}
`;
